import { createFileRoute, Link } from '@tanstack/react-router';
import { BrandMark } from '../components/layout/BrandMark';

export const Route = createFileRoute('/terms')({
  component: TermsPage,
});

function TermsPage() {
  return (
    <div className="min-h-svh bg-background px-4 py-10 sm:py-14">
      <div className="mx-auto max-w-2xl">
        <div className="mb-6">
          <BrandMark />
        </div>
        <div className="rounded-2xl border border-border bg-card p-6 sm:p-8">
          <h1 className="mb-6 text-2xl font-semibold tracking-tight">Användarvillkor</h1>

          <div className="space-y-4 text-sm leading-relaxed">
            <p>
              <span className="text-muted-foreground">Senast uppdaterad:</span> 2025-06-01
            </p>

            <h2 className="pt-2 text-[15px] font-semibold tracking-tight">1. Tjänsten</h2>
            <p>
              Budgie är en personlig budgetapp som hjälper dig att hantera din ekonomi genom att
              importera och kategorisera banktransaktioner. Tjänsten är avsedd för privat bruk.
            </p>

            <h2 className="pt-2 text-[15px] font-semibold tracking-tight">2. Bankintegration</h2>
            <p>
              Budgie använder Enable Banking för att hämta kontoinformation och transaktioner från
              din bank. Genom att ansluta din bank godkänner du att:
            </p>
            <ul className="list-disc space-y-1 pl-5">
              <li>Enable Banking agerar som kontoinformationstjänst (AISP)</li>
              <li>Kontoinformation hämtas enligt PSD2-regelverket</li>
              <li>Du kan när som helst återkalla åtkomsten via din bank eller Enable Banking</li>
            </ul>

            <h2 className="pt-2 text-[15px] font-semibold tracking-tight">3. Ditt ansvar</h2>
            <ul className="list-disc space-y-1 pl-5">
              <li>Du ansvarar för att hålla dina inloggningsuppgifter säkra</li>
              <li>Du ska inte dela ditt konto med andra</li>
              <li>Du ansvarar för att informationen du matar in manuellt är korrekt</li>
            </ul>

            <h2 className="pt-2 text-[15px] font-semibold tracking-tight">4. Ansvarsbegränsning</h2>
            <p>
              Budgie tillhandahålls &quot;i befintligt skick&quot; utan garantier. Vi ansvarar inte
              för:
            </p>
            <ul className="list-disc space-y-1 pl-5">
              <li>Felaktig information från banken eller Enable Banking</li>
              <li>Avbrott i tjänsten eller bankens API</li>
              <li>Ekonomiska beslut baserade på information i appen</li>
            </ul>

            <h2 className="pt-2 text-[15px] font-semibold tracking-tight">5. Uppsägning</h2>
            <p>
              Du kan när som helst radera ditt konto. Vid radering tas alla dina uppgifter bort
              permanent.
            </p>

            <h2 className="pt-2 text-[15px] font-semibold tracking-tight">6. Integritet</h2>
            <p>
              Hanteringen av dina personuppgifter beskrivs i vår{' '}
              <Link to="/privacy" className="text-primary hover:underline">
                integritetspolicy
              </Link>
              .
            </p>

            <h2 className="pt-2 text-[15px] font-semibold tracking-tight">7. Kontakt</h2>
            <p>
              Vid frågor om dessa villkor, kontakta oss via e-post:{' '}
              <a href="mailto:privacy@strengthara.com" className="text-primary hover:underline">
                privacy@strengthara.com
              </a>
            </p>
          </div>
        </div>

        <div className="mt-6 text-center">
          <Link to="/login" className="text-sm text-muted-foreground hover:text-foreground">
            ← Tillbaka till inloggning
          </Link>
        </div>
      </div>
    </div>
  );
}
